import {
    useEffect, useState
} from 'react';
import {
    Card, CardContent, CardDescription, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
    secretKeysService
} from 'shared/api';
import {
    useParams
} from 'react-router-dom';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import {
    Label
} from 'shared/components/ui/label';
import {
    Alert,
    AlertDescription
} from 'shared/components/ui/alert';
import {
    Badge
} from 'shared/components/ui/badge';
import ConfigFieldsDisplay from './config-fields-display';

const fields = [{
    label: 'Api Key',
    value: 'milvusApiKey',
    copyable: true,
    type: 'masked',
}, {
    label: 'Milvus Cloud Region',
    value: 'milvusCloudRegion',
    copyable: true,
}, {
    label: 'Milvus Cluster Id',
    value: 'milvusClusterId',
    copyable: true,
}, {
    label: 'Milvus Public Endpoint',
    value: 'milvusPublicEndpoint',
    copyable: true,
}];

export default function MilvusConfig() {
    const [secretKeys, setSecretKeys] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const {
        oragID
    } = useParams();

    useEffect(() => {
        secretKeysService.getConfigDetails(oragID, 'milvus')
            .then((res) => {
                setSecretKeys({
                    keys: res.data.milvusKeys
                });
            }).catch(error => {

                setError(error?.response?.message || 'Something went wrong');
            }).finally(() => {
                setLoading(false);
            });

    }, []);

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    if (error) {
        return <h1> Error: {error} </h1>;
    }

    return (
        <OrganizationKeyCard
            keys={secretKeys.keys}
        />
    );
}

const OrganizationKeyCard = ({
    keys
}) => {

    return (
        <Card>
            <CardHeader>
                <CardTitle>Milvus Keys</CardTitle>
                <CardDescription>Manage your organization's configuration keys</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
                <div className="space-y-3">
                    <div className="space-y-2">
                        <Label htmlFor={'db-store-type'}> Milvus Store Type: </Label>
                        <Badge variant="outline" className="text-sm">{keys.keyType || 'Not Active'}</Badge>
                    </div>
                </div>

                {keys.keyType === 'dedicated' ? (
                    <div className="space-y-3">
                        {fields.length > 0 ? (
                            <ConfigFieldsDisplay fields={fields.map((item) => ({
                                ...item,
                                value: keys[item.value] || ''
                            }))} />
                        ) : (
                            <div className="py-8 text-center text-muted-foreground">
                                <p>Connection guide documentation will be displayed here.</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <Alert>
                        <AlertDescription>
                            Please contact our customer service for assistance with Dedicated configuration. Our team will
                            help you set up the advanced features.
                        </AlertDescription>
                    </Alert>
                )}
            </CardContent>
        </Card>
    );
};